<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction. Northern Virginia Confidential</a></p>
<p class="toc1"><a href="#/chapter01">1. Nine Pints: Bleeding the General at Mount Vernon</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Halfpenny Hitler: Nazi Power in Arlington</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Chaff Before a Whirlwind: Arsenic and Old Lace in Leesburg</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. First Contact: Murder and Mayhem in the New World</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Tobacco Insurrection: East Versus West in Prince William County</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Supervisors for Sale: Zoning Scandal Rocks Fairfax County</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Fire and Brimstone: Occupiers Bully Old Town Alexandria</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Monte Carlo No More: Crime and Corruption in Rosslyn and Del Ray</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The Code Duello: Henry Clay Versus John Randolph in Arlington</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Ark of the Commonwealth: Floating Brothels Service Old Town</span></p>
<p class="toc1"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0292ea68